import React from 'react';

const Footer = () => (
  <footer className="footer">
    <div>
      © {new Date().getFullYear()} Anlar Oto Dizayn — Tüm hakları saklıdır.&nbsp;&nbsp;·&nbsp;&nbsp;
      <a href="https://instagram.com/anlarotodizayn" target="_blank" rel="noreferrer">Instagram</a>
    </div>
  </footer>
);

export default Footer;
